import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { connect } from 'react-redux';
import Link from 'next/link';
import { headN } from '@cullylarson/f';
import loadFeaturedPartTypeList from '@@client/parts/part-type/loadFeaturedPartTypeList';

var OneFeaturedPartType = function OneFeaturedPartType(_ref) {
  var partTypeInfo = _ref.partTypeInfo;
  var categoryUrl = '/parts?part=' + encodeURIComponent(partTypeInfo.defaultSlug);
  return /*#__PURE__*/_jsx(Link, {
    href: categoryUrl,
    children: /*#__PURE__*/_jsx("a", {
      children: partTypeInfo.defaultName
    })
  });
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var partType = _ref2.parts.partType;
  return {
    partTypeStore: partType
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

var FeaturedPartTypesSidebar = function FeaturedPartTypesSidebar(_ref3) {
  var partTypeStore = _ref3.partTypeStore;
  loadFeaturedPartTypeList();
  if (partTypeStore.featuredList.doing) return null;
  if (!partTypeStore.featuredList.entities.length) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-105255911",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "jsx-105255911",
        children: "Popular Part Categories"
      }), /*#__PURE__*/_jsx("ul", {
        className: "jsx-105255911",
        children: headN(8, partTypeStore.featuredList.entities).map(function (x) {
          return /*#__PURE__*/_jsx("li", {
            className: "jsx-105255911",
            children: /*#__PURE__*/_jsx(OneFeaturedPartType, {
              partTypeInfo: x
            })
          }, x.id);
        })
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "105255911",
      children: ["h3.jsx-105255911{text-transform:uppercase;color:white;font-weight:700;background:-webkit-gradient(linear,left top,left bottom,from(#1C357D),to(#182661));background:linear-gradient(#1C357D,#182661);padding:10px 20px;margin:0;}", "ul.jsx-105255911{list-style:none;background:white;margin:0;padding:17px 20px;}", "li.jsx-105255911{margin-bottom:11px;font-size:0.875rem;}", "li.jsx-105255911:last-child{margin-bottom:0;}"]
    })]
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedPartTypesSidebar);